const pbs_locations = {
	description:
		"Verwalten Sie die verfügbaren PBS-Standorte für den Kunden. Mit den Schiebereglern kann bestimmt werden, ob ein Knoten für den Kunden verfügbar ist, um einen kostenlosen PBS und/oder einen bezahlten PBS zu erstellen. Wenn beide Schieberegler deaktiviert sind, können Kunden an diesem Knoten keine neuen PBS erstellen. Wenn alle Schieberegler aller Knoten deaktiviert sind, funktioniert der Dienst nicht, da der Kunde dann kein Land oder keinen Ort auswählen kann.",
	messages: {
		pbs_allow_free_updates: "Status für freie PBSs erfolgreich auf Knoten geändert.",
		pbs_allow_paid_updates: "Status für bezahlte PBSs erfolgreich auf Knoten geändert.",
	},
	node: {
		pbs_allow_free: {
			label: "Freie PBSs auf dem Knoten zulassen",
		},
		pbs_allow_paid: {
			label: "Bezahlte PBSs auf Knoten zulassen",
		},
		pbs_usage: {
			cant_fetch: "nicht verfügbar",
			label: "PBS-Nutzung",
		},
	},
	title: "PBS-Standortverwaltung",
};

export default pbs_locations;
